import * as React from "react";
import styled, { css } from "../../../styled/index";

interface ContentProps extends React.HtmlHTMLAttributes<HTMLDivElement> {
  width: ThemeContentSizes | "full";
}

const ContentComponent = styled("div")<ContentProps>`
  margin: 0 auto;
  width: 100%;
  max-width: ${({ width, theme }) => width === "full" ? "100%" : `${theme.content_width[width]}px` };
`;

export const Content  = (props: ContentProps) => <ContentComponent {...props}/>;
